import { FamilyScreen } from "@/features/family/familyScreen";

export default function FamilyTab() {
    return <FamilyScreen />;
}
